/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

import {
  egg_type_enum,
  item,
  record_item,
  repeat_num_type,
  rest_product_item,
  win_product_item,
} from './interface'

// 贪砸金蛋信息主页 http://wiki.xunlei.cn/pages/viewpage.action?pageId=96460692
export const golden_egg_info = createAsyncThunk(
  'golden_egg_info',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          'num' | 'balance' | 'st' | 'et' | 'list' | 'record'
        >
      >
    >(
      '/live/activity/golden_egg_info',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 砸蛋接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=96460696
export const golden_egg_smash = createAsyncThunk(
  'golden_egg_smash',
  async (
    arg: {
      type: egg_type_enum
      num: repeat_num_type
      room_id: number
    },
    store: any
  ) => {
    const resp = await http.post<
      HiyaRes<{
        err_msg: string
        status: number
        products: win_product_item[]
      }>
    >(
      '/live/activity/golden_egg_smash',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return Object.assign(resp.data.data, {hammerType: arg.type})
  }
)

interface InitialStateType {
  // 页面主信息
  num?: number[]
  balance?: number
  st?: string
  et?: string
  list?: item[]
  record?: record_item[]
  // 待展示奖品列表
  goldProductions: rest_product_item[]
}

const initialState: InitialStateType = {goldProductions: []}

export const HitEggSlice = createSlice({
  name: 'HitEgg',
  initialState,
  reducers: {
    removeLastGoldProductions: (state, action: PayloadAction) => {
      if (state.goldProductions.length) {
        const restProductions = state.goldProductions.slice(1)
        state.goldProductions = restProductions
      }
    },
    setBalance(state, action: PayloadAction<number>) {
      return Object.assign(state, {
        balance: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    // 主页
    builder.addCase(golden_egg_info.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    // 合并待展示奖品
    builder.addCase(golden_egg_smash.fulfilled, (state, action) => {
      state.goldProductions = [
        ...state.goldProductions,
        {
          products: action.payload.products,
          hammerType: action.payload.hammerType,
        },
      ]
    })
  },
})
export default HitEggSlice.reducer
export const HitEggActions = HitEggSlice.actions
